var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChildbgmtop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 293,
    viewBox: "0 0 421 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421 31.4944C421 42.0123 395.668 72.8929 368.96 69.8394C342.251 66.7858 286.938 22.6517 217.224 41.3125C147.51 59.9732 129.87 9.51729 76 0.695856C22.1302 -8.12558 0 69.8394 0 69.8394V292.197H421C421 292.197 421 20.9766 421 31.4944Z",
    fill: "#7A53FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildbgmtop);
export default __webpack_public_path__ + "static/media/childbgmtop.1c813933468e60dec7087e7d5f5c7d4f.svg";
export { ForwardRef as ReactComponent };